/* eslint-disable react-hooks/exhaustive-deps */
import { Avatar, Chip, Icon, IconButton, Paper, Tooltip } from "@mui/material";
import React, { CSSProperties, FC, useEffect, useState } from "react";
import { Cidade } from "src/components/geral/RegioesDataTable/types";
import { InputDateTimeFilter } from "src/framework/components/forms/inputs/InputDateTimeFilter";
import { InputSelectSimple } from "src/framework/components/forms/inputs/InputSelectSimple";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { DataGridStore } from "src/framework/store/DataGridStore";
import { DEFAULT_VERTICAIS, SITUACAO, Verticais } from "../types";
import { VerticaisForm } from "../VerticaisForm";
import { ANALISTA_FIELD, CIDADE_FIELD, COMPONENTE_FIELD, DATA_CRIACAO_FINAL_FIELD, DATA_CRIACAO_INICIAL_FIELD, DATA_INTEGRACAO_FINAL_FIELD, DATA_INTEGRACAO_INICIAL_FIELD, DISTRIBUIDOR_FIELD, EV_FIELD, FILTER, paths, REVENDA_FIELD, SITUACAO_FIELD, DATA_ETAPA_FINAL_FIELD, DATA_ETAPA_INICIO_FIELD, ETAPA_VENDA_FIELD, VerticaisManager, PRIORIDADE_FIELD } from "../VerticaisManager";
import { Componente } from "../../componentes/types";
import { Filter } from "src/framework/commons/FilterUtil";
import theme from "src/theme/light";
import { Conta } from "src/components/contas/contas/types";
import { cidades$, componentes$, distribuidores$, engenharia$, evs$, getAnalistasEngenharia, getCidades, getComponentes, getDistribuidores, getEstados, getEvs, getGruposEstrutura, getLimitacoesProjetos, getRevendas, grupoEstrutura$, revendas$, verificarSegmentoConta } from "src/store/global.store";
import { useObservable } from "src/framework/store/storeUtil";
import { LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS, LISTA_PRIORIDADE_PROJETOS_VERTICAIS, LISTA_SITUACAO_PROJETOS_VERTICAIS, TIPO_SERVICO_REVENDA } from "src/components/projetos/constants";
import { parseEtapaVenda, parsePrioridadeProjeto, parsePrioridadeProjetoColor, parseStatusProjeto } from "src/components/projetos/Listagem";
import { PrioridadeType } from "src/components/projetos/types";
import { red } from "@mui/material/colors";
import { ProjetoSolicitacaoPausaDom, ProjetosSolicitacaoPausaModal } from "../SolicitacaoPausa";
import { Settings, PauseCircleOutline } from "@mui/icons-material";
import { DownloadUtil } from "src/framework/commons/DownloadUtil";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { openRedirectVerticais$ } from "src/App";
import { ModalRedirectVerticais } from "src/framework/layouts/Main/redirect/verticais";
import adminStore from "src/store/AdminStore";
import { ModalRevendaServicoDesabilitado } from "src/components/projetos/containers/ModalRevendaServicoDesabilitado";
import { LoginStore } from "src/framework/store/LoginStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { InputDateTime } from "src/framework/components/forms/inputs/InputDateTime";
import { ActionMenu, ActionMenuProperties } from "src/framework/components/base/ActionMenu";
import { ColumnDefinition } from "src/framework/store/DataTableStore";
import { DataGrid, DataGridProperties } from "src/framework/components/base/DataGrid";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { DateUtil } from "src/framework/commons/DateUtils";

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);
const VerticaisDataTable: FC = () => {
    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    const permiteEditar = PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_EDITAR, permissoes);
    const permiteNovo = PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_EDITAR, permissoes);
    const permiteVisualizar = PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_VISUALIZAR, permissoes);
    const [dataSolicitacaoPausa, setSolicitacaoPausa] = useState<ProjetoSolicitacaoPausaDom | null>(null);
    const [openSolicitacaoPausa, setOpenSolicitacaoPausa] = useState<boolean>(false);
    // States
    const cidadeListState = useObservable(cidades$)
    const distribuidoresState = useObservable(distribuidores$)
    const revendasState = useObservable(revendas$)
    const evsState = useObservable(evs$)
    const engenheirosState = useObservable(engenharia$)
    const cachedComponenteState = useObservable(componentes$)
    const estruturasState = useObservable(grupoEstrutura$)

    const [dataGridStore] = useState(new DataGridStore(api));
    const [tabManutencao, setTabManutencao] = useState("list");
    const [currentEditReadOnly, setCurrentEditReadOnly] = React.useState<boolean>(false);
    const [currentEdit, setCurrentEdit] = useState<any>(null);
    const [newRow, setNewRow] = useState<any>(null);
    const [revendaComServicoDesabilitadoWarningModal, setRevendaComServicoDesabilitadoWarningModal] = useState<{ status: boolean; idProjeto: number | null, onConfirm: () => void }>({ status: false, onConfirm: () => {}, idProjeto: null })

    const [componentesState, setComponentesState] = useState<Componente[]>(cachedComponenteState || []);
    const openRedirectVerticais = useObservable(openRedirectVerticais$);

    /**
     * Definição dos filtros
     */
    const [filterState, setFilterState] = useState<Filter[]>(FILTER || []);

    // Methods
    const handleChangeTabManutencao = (tab: string) => {
        setTabManutencao(tab);
    }

    const doFinalizar = (row: any, triangular: boolean) => {
        confirmationDialog.setup({
            title: "Aviso!",
            content: `Deseja enviar para pagamento o projeto ${row.codigo_venda}?`,
            onClose: () => {
                confirmationDialog.close();
            },
            onConfirmation: async () => {
                confirmationDialog.close();

                const validarSegmentoConta = await verificarSegmentoConta({ 
                    segmento: row?.segmento || 'on', 
                    revendaId: row?.revenda_id || row?.revenda?.id || undefined, 
                    distribuidorId: row?.distribuidor_id || row?.distribuidor?.id || undefined
                });
                if (!validarSegmentoConta) return;

                finalizar(row.codigo_venda, triangular);
            }
        })
        confirmationDialog.open()
    }

    const readOnly = (row: Verticais): boolean => {
        // Cancelado não edita
        if (["cancelado", "finalizado"].includes(row.situacao)) {
            return true;
        }

        // Etapas que permitem edição
        if (!["sla_engenharia", "pre_orcamento"].includes(row.etapa_venda || "sla_engenharia")) {
            return true;
        }

        return false;
    }

    const doSolicitacaoPausa = async (data: ProjetoSolicitacaoPausaDom) => {
        const response: IDataResponse = await manager.solicitacaoPausa(data.id || 0, data.solicitacao, data.envia_email, data.envia_email_interno);
        if (response.statusCode === STATUS_CODE.OK) {
            dataGridStore.setFilter([...filterState]);
            dataGridStore.list();
            confirmationDialog.close();
        }
    }

    const doDownload = async (id: number, codigoVenda: string): Promise<void> => {
        const response = await manager.downloadAnexos(id);
        if (response?.statusCode === STATUS_CODE.OK && response?.data) {
            DownloadUtil.zip(response.data, codigoVenda + "-Anexos");
        } else {
            if (response?.message) {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: response?.message,
                    timeOut: 3000,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                });
                notifierStore.setOpen(true);
            }
        }
    }

    const renderActionMenu = (row: any) => {
        let menu: ActionMenuProperties = {
            selected: null,
            menuItens: [],
        };

        const situacao: string = (row as Verticais).situacao.toString();
        const etapa: string = `${(row as Verticais)?.etapa_venda}`;

        if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_DOWNLOAD_ANEXO, permissoes)) {
            menu.menuItens.push({
                label: "Download anexo(s)",
                key: `download-${row.id}`,
                icon: "download",
                onClick: () => {
                    adminStore.buscarProjeto(row?.id, true).then((resp) => {
                        if (resp?.length) doDownload(row.id, row.codigo_venda);
                    });
                },
            });
        }
        if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_SOLICITAR_PAUSA, permissoes)) {
            if (["pendente"].includes(situacao) && ["sla_engenharia"].includes(etapa)) {
                menu.menuItens.push({
                    label: "Solicitar Pausa",
                    key: `solicitacao-pausa-${row.id}`,
                    icon: "pause",
                    onClick: () => {
                        adminStore.buscarProjeto(row?.id, true).then((resp) => {
                            if (resp?.length) {
                                setSolicitacaoPausa({
                                    id: row?.id,
                                    solicitacao: "",
                                    envia_email: false,
                                    envia_email_interno: false,
                                });
                                setOpenSolicitacaoPausa(true);
                            }
                        });
                    },
                })
            }
        }

        if (situacao === "pendente" && ["pre_orcamento"].includes(etapa)) {
            menu.menuItens.push({
                label: "Enviar p/ pagamento",
                key: `finalizar-${row.id}`,
                icon: "done",
                onClick: () => {
                    confirmationDialog.setup({
                        title: "Aviso!",
                        content: `Enviar para pagamento com triangulação de nota?`,
                        onClose: () => {
                            confirmationDialog.close();
                            doFinalizar(row, false)
                        },
                        onConfirmation: () => {
                            confirmationDialog.close();
                            doFinalizar(row, true)
                        }
                    })

                    adminStore.buscarProjeto(row?.id, true).then((resp) => {
                        if (resp?.length) {
                            const projeto = resp[0];
                            if (projeto.servico === TIPO_SERVICO_REVENDA && Number(projeto.valor_servico || 0) > 0 && projeto.revenda && !projeto.revenda?.segmentos_servico?.includes(projeto?.segmento?.includes("on") ? "on" : "off")) {
                                setRevendaComServicoDesabilitadoWarningModal({
                                    status: true,
                                    idProjeto: row.id,
                                    onConfirm: () => {
                                        setRevendaComServicoDesabilitadoWarningModal({ status: false, idProjeto: null, onConfirm: () => {} });
                                        confirmationDialog.open();
                                    }
                                })
                                return;
                            }

                            confirmationDialog.open();
                        }
                    });
                },
            });
        }
        if (PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ENGENHARIA_CANCELAR, permissoes)) {
            if (["pendente", "expirado"].includes(situacao) && ["sla_engenharia", "pre_orcamento"].includes(etapa)) {
                menu.menuItens.push({
                    label: "Cancelar",
                    key: `cancelar-${row.id}`,
                    icon: "cancel",
                    onClick: () => {
                        confirmationDialog.setup({
                            title: "Aviso!",
                            content: `Deseja cancelar o projeto ${row.codigo_venda}?`,
                            onClose: () => {
                                confirmationDialog.close();
                            },
                            onConfirmation: () => {
                                const projetos: string[] = [`${row.id}`]
                                cancelar(projetos);
                            }
                        })

                        adminStore.buscarProjeto(row?.id, true).then((resp) => {
                            if (resp?.length) confirmationDialog.open()
                        });
                    },
                });
            }
        }

        return (
            <>
                <ActionMenu {...menu} />
            </>
        );
    };

    /**
     * Definiçao das colunas
     */
    const defaultColumn: ColumnDefinition[] = [
        {
            field: "",
            headerName: "",
            sortable: false,
            width: 5,
            render: (row: any) => {
                const disabled: boolean = readOnly(row);
                return <>
                    <IconButton
                        disabled={!((permiteEditar && !disabled) || (permiteVisualizar && disabled))}
                        size="small"
                        onClick={async () => {
                            adminStore.buscarProjeto(row?.id, true).then(async (resp) => {
                                if (resp?.length) await getEditRow(row, disabled);
                            });
                        }}
                    >
                        {(disabled ? <Icon>list</Icon> : <Icon>edit</Icon>)}
                    </IconButton>
                </>
            },
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            width: 10,
            render: renderActionMenu,
        },
        {
            field: "prioridade",
            headerName: "Prior.",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 40,
            align: "center",
            render: (row: any, style?: CSSProperties): React.ReactNode => {
                const prioridade: PrioridadeType = row?.prioridade || "baixa";
                const prioridadeLabel = parsePrioridadeProjeto(prioridade as any);
                const color = parsePrioridadeProjetoColor(prioridade as any);
                return (
                    <Tooltip title={`Prioridade: ${prioridadeLabel}`} placement="bottom">
                        <Avatar aria-label="recipe" style={{ backgroundColor: color }}>
                            {prioridadeLabel.charAt(0)}
                        </Avatar>
                    </Tooltip>
                )
            }
        },
        {
            field: "codigo_venda",
            headerName: "Código projeto",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 40,
        },
        {
            field: "servico",
            headerName: "Escopo",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 40,
            align: "center",
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);

                let tootip = "Apenas Produto";
                let sigla = "P"
                switch (projeto.servico) {
                    case "intelbras":
                        tootip = "Turnkey";
                        sigla = "TK";
                        break;
                    case "revenda":
                        tootip = "Produto + Serviço";
                        sigla = "PS";
                        break;
                }
                return (
                    <>
                        <Tooltip title={tootip} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help" }}>
                                {sigla}
                            </span>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: "titulo",
            headerName: "Título",
            sortable: true,
            type: TypeRecords.TEXT,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.titulo ? String(projeto?.titulo) : ""}</>
            }
        },
        {
            field: "etapa_Venda",
            headerName: "Etapa Venda",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return (
                    <>
                        <Tooltip title={`Data ${Formater.toString(projeto.data_etapa_venda, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help" }}>
                                {parseEtapaVenda((projeto?.etapa_venda as any))}
                            </span>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: "situacao",
            headerName: "Situação",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);

                // Expirado
                if (projeto.situacao === "expirado") {
                    return (
                        <Tooltip title={`Data expiração ${Formater.toString(projeto.data_expiracao, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.warning.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Cancelado
                if (projeto.situacao === "cancelado") {
                    return (
                        <Tooltip title={`Data cancelamento ${Formater.toString(projeto.data_cancelamento, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.error.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Pausado
                if (projeto.situacao === "pausado") {
                    return (
                        <Tooltip title={`Data solicitação de pausa ${Formater.toString(projeto.data_solicitacao_pausa, TypeRecords.DATE_TIME)}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.warning.main }}>
                                {parseStatusProjeto(projeto.situacao as any)}
                            </span>
                        </Tooltip>
                    )
                }

                // Revisão
                if (row.quantidade_revisoes && row.etapa_venda === "sla_engenharia") {
                    return (
                        <Tooltip title={`Projeto possui ${row.quantidade_revisoes} revis${row.quantidade_revisoes > 1 ? "ões" : "ão"}`} placement="bottom">
                            <span style={{ textDecoration: "underline", cursor: "help", color: theme.palette.info.main }}>
                                {`Revisão (${row.quantidade_revisoes})`}
                            </span>
                        </Tooltip>
                    )
                }

                let color = "inherit"
                if (projeto.situacao === "finalizado") {
                    color = theme.palette.success.main;
                }

                return (
                    <span style={{ color: color }}>
                        {parseStatusProjeto(projeto.situacao as any)}
                    </span>
                )
            }
        },
        {
            field: "ev_id",
            headerName: "Profissional de Vendas",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.ev_nome ? String(projeto?.ev_nome) : ""}</>
            }
        },
        {
            field: "distribuidor_id",
            headerName: "Distribuidor/Revenda",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{`${projeto?.fantasia_distribuidor ? String(projeto?.fantasia_distribuidor) : ""}${projeto?.fantasia_revenda ? "/" + projeto?.fantasia_revenda : ""}`}</>
            }

        },
        {
            field: "",
            headerName: "Endereço",
            type: TypeRecords.TEXT,
            render: (row: any) => {
                const projeto: any = row;
                return <><Tooltip title={`${projeto?.endereco_proposta ? projeto.endereco_proposta + ", " : ""}${projeto?.cidade_nome}/${String(projeto?.uf).toUpperCase()}`}><span>{`${projeto?.cidade_nome}/${String(projeto?.uf).toUpperCase()}`}</span></Tooltip></>
            }
        },
        {
            field: "analista_id",
            headerName: "A. engenharia",
            sortable: true,
            type: TypeRecords.TEXT,
            width: 80,
            render: (row: any) => {
                const projeto: Verticais = (row as Verticais);
                return <>{projeto?.analista_nome ? String(projeto?.analista_nome) : ""}</>
            }

        },
        {
            field: "ultima_revisao",
            headerName: "Criação/Revisão",
            type: TypeRecords.DATE_TIME,
            sortable: true,
            width: 40,
            render: (row: any, style?: CSSProperties): React.ReactNode => {
                if (row.ultima_revisao) {
                    return (
                        <span>
                            {`${Formater.toString(row.ultima_revisao, TypeRecords.DATE_TIME)} (${DateUtil.diffDaysNonAbs(DateUtil.nowDateNonTime(), new Date(row.ultima_revisao))})`}
                        </span>
                    )
                }

                return (
                    <span style={{ color: red[500] }}>
                        {`${Formater.toString(row.created_at, TypeRecords.DATE_TIME)} (${DateUtil.diffDaysNonAbs(DateUtil.nowDateNonTime(), new Date(row.created_at))})`}
                    </span>
                )
            }
        },
        {
            field: "created_updated_at",
            headerName: "Data atualização",
            type: TypeRecords.DATE_TIME,
            sortable: true,
            width: 40,
            render: (row: any, style?: CSSProperties): React.ReactNode => {
                if (row.updated_at) {
                    return (
                        <span>
                            {Formater.toString(row.updated_at, TypeRecords.DATE_TIME)}
                        </span>
                    )
                }

                return (
                    <span style={{ color: red[500] }}>
                        {Formater.toString(row.created_at, TypeRecords.DATE_TIME)}
                    </span>
                )
            }
        },
    ];

    // Inits
    dataGridStore.setIncludes(["cidade", "revenda", "distribuidor", "analista"]);
    dataGridStore.setFilter(filterState);
    dataGridStore.setOrderBy(["prioridade-desc", "ultima_revisao-desc"]);
    dataGridStore.setEnableExport(true);
    dataGridStore.setColumnDefinitions(defaultColumn);

    const dataGridProperties: DataGridProperties = {
        columnDefinitions: defaultColumn,
        title: "Verticais",
        height: "60vh",
        width: "100%",
        provider: api,
        path: {
            list: "projetos/consultar",
            create: "projetos",
            read: "projetos",
            update: "projetos",
            delete: "projetos",
        },
        enableSearch: true,
        searchFields: ["codigo_venda"],
        store: dataGridStore,
    };

    const init = async (): Promise<any> => {

        return Promise.all([
            getCidades(),
            getEstados(),
            getGruposEstrutura(),
            getDistribuidores(),
            getRevendas(),
            getEvs(),
            getAnalistasEngenharia(),
            getComponentes(),
            getLimitacoesProjetos()
        ])
    }


    // Effects
    useEffect(() => {
        setFilterState(FILTER);
        init().then(() => {
            setComponentesState(componentes$.getValue()?.data || [])
            setNewRow({ ...DEFAULT_VERTICAIS });
            dataGridStore.list();
        });
    }, [])

    const getEditRow = async (row: any, readOnly: boolean) => {
        const _row = await dataGridStore.find(
            row.id,
            ["cidade", "solicitacao", "revisoes", "componentes", "ev", "analista", "distribuidor", "revenda", "uploads", "disposicoes", "grupo_estrutura", "anexos", "descontos"]
        );
        setCurrentEditReadOnly(readOnly);
        setCurrentEdit({ ...DEFAULT_VERTICAIS, ..._row });
        setTabManutencao("edicao");
    }

    const afterSave = (response: IDataResponse, finalizar?: boolean): void => {
        if (response.statusCode === STATUS_CODE.CREATED) {
            setNewRow({ ...DEFAULT_VERTICAIS })
            confirmationDialog.setup({
                title: `Projeto (${response.data[0].codigo_venda}) salvo com sucesso! `,
                content: "Deseja criar novo projeto?",
                onClose: () => {
                    dataGridStore.setFilter([...filterState]);
                    dataGridStore.list();
                    setTabManutencao("list");
                    setNewRow({ ...DEFAULT_VERTICAIS })
                    confirmationDialog.close();
                },
                onConfirmation: () => {
                    setNewRow({ ...DEFAULT_VERTICAIS })
                    confirmationDialog.close();
                }
            })
            confirmationDialog.open()
        } else if (response.statusCode === STATUS_CODE.OK) {
            if (finalizar) {
                manager.finalizar(response.data[0].codigo_venda, true)
            }
            confirmationDialog.setup({
                title: "Projeto salvo com sucesso!",
                content: "Continuar edição?",
                onClose: () => {
                    dataGridStore.setFilter([...filterState]);

                    if (response.statusCode === STATUS_CODE.OK) {
                        setCurrentEdit(null);
                    }
                    dataGridStore.list();
                    setTabManutencao("list");
                    confirmationDialog.close();
                },
                onConfirmation: () => {
                    getEditRow(response.data[0], false)
                    confirmationDialog.close();
                }
            });
            confirmationDialog.open()
        }
    }

    const cancelar = async (projetos: string[]): Promise<void> => {
        const response: IDataResponse = await manager.cancelar(projetos)
        if (response.statusCode === STATUS_CODE.OK) {
            dataGridStore.setFilter([...filterState]);
            dataGridStore.list();
            setTabManutencao("list");
            confirmationDialog.close();
        }
    }

    const finalizar = async (codigoVenda: string, triangular: boolean): Promise<void> => {
        const response: IDataResponse = await manager.finalizar(codigoVenda, triangular)
        if (response.statusCode === STATUS_CODE.OK) {
            dataGridStore.setFilter([...filterState]);
            dataGridStore.list();
            setTabManutencao("list");
            confirmationDialog.close();
        }
    }

    return <>
        <Paper elevation={0}>
            <TabControl
                currentTabName={tabManutencao}
                onChangeTab={handleChangeTabManutencao}
            >
                <TabContent name={"list"} label={"Listagem"} visible={true}>
                    <div className="X12" id="grid" hidden={tabManutencao !== "list"}>
                        <DataGrid
                            {...dataGridProperties}
                            filters={
                                <>
                                    <div className="X12 M2">
                                        <InputSelectSimple
                                            allowNull
                                            list={LISTA_SITUACAO_PROJETOS_VERTICAIS}
                                            label="Situação"
                                            defaultValue={SITUACAO.PENDENTES}
                                            value={filterState[SITUACAO_FIELD.index].value}
                                            onChange={(value) => {
                                                filterState[SITUACAO_FIELD.index].value = value;
                                                setFilterState([...filterState]);
                                                dataGridStore.setFilter(filterState);
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`listagem-verticais-cidade-cb`}
                                            key={`listagem-verticais-cidade-cb`}
                                            label={"Cidade"}
                                            textField="nome"
                                            valueField="id"
                                            options={cidadeListState?.data || []}
                                            value={filterState[CIDADE_FIELD.index].value}
                                            autoComplete
                                            renderOptions={(option: any) => {
                                                return `${option.nome} - ${option.estado_id}`
                                            }}
                                            renderOptionsLabel={(option: any) => {
                                                return `${option.nome} - ${option.estado_id}`
                                            }}
                                            onChange={(value: Cidade) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[CIDADE_FIELD.index].value = value
                                                setFilterState(filter)
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`verticais-data-table-componente`}
                                            key={`verticais-data-table-componente`}
                                            label={"Componente"}
                                            textField="modelo"
                                            valueField="id"
                                            options={cachedComponenteState?.data || []}
                                            value={filterState[COMPONENTE_FIELD.index].value}
                                            autoComplete
                                            renderOptions={(option: Componente) => {
                                                return `${option.id} - ${option.modelo}`
                                            }}
                                            renderOptionsLabel={(option: Componente) => {
                                                return `${option.id} - ${option.modelo}`
                                            }}
                                            onChange={(value: Componente) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[COMPONENTE_FIELD.index].value = value
                                                setFilterState(filter);
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`verticais-data-table-distribuidor`}
                                            key={`verticais-data-table-distribuidor`}
                                            options={distribuidoresState?.data || []}
                                            label={"Distribuidor"}
                                            value={filterState[DISTRIBUIDOR_FIELD.index].value}
                                            textField="nome"
                                            valueField="id"
                                            renderOptions={(option: Conta) => {
                                                return `${option.cnpj_cpf} - ${option.nome}`
                                            }}
                                            renderOptionsLabel={(option: Conta) => {
                                                return `${option.nome} - ${option.cnpj_cpf}`
                                            }}
                                            onChange={(value: Conta) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[DISTRIBUIDOR_FIELD.index].value = value
                                                setFilterState(filter);
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`verticais-data-table-revenda`}
                                            key={`verticais-data-table-revenda`}
                                            options={revendasState?.data || []}
                                            label={"Revenda"}
                                            value={filterState[REVENDA_FIELD.index].value}
                                            textField="nome"
                                            valueField="id"
                                            renderOptions={(option: Conta) => {
                                                return `${option.cnpj_cpf} - ${option.nome}`
                                            }}
                                            renderOptionsLabel={(option: Conta) => {
                                                return `${option.nome} - ${option.cnpj_cpf}`
                                            }}
                                            onChange={(value: Conta) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[REVENDA_FIELD.index].value = value
                                                setFilterState(filter)
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`verticais-data-table-ev`}
                                            key={`verticais-data-table-ev`}
                                            options={evsState?.data || []}
                                            label="Profissional de Vendas"
                                            value={filterState[EV_FIELD.index].value}
                                            textField="nome"
                                            valueField="id"
                                            renderOptions={(option: Conta) => {
                                                return option.nome;
                                            }}
                                            renderOptionsLabel={(option: Conta) => {
                                                return option.nome;
                                            }}
                                            onChange={(value: Conta) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[EV_FIELD.index].value = value
                                                setFilterState(filter)
                                            }}
                                        />

                                    </div>
                                    <div className="X12 M3">
                                        <InputComboBoxList
                                            id={`verticais-data-table-analista`}
                                            key={`verticais-data-table-analista`}
                                            options={engenheirosState?.data || []}
                                            label="Eng. verticais"
                                            value={filterState[ANALISTA_FIELD.index].value}
                                            textField="nome"
                                            valueField="id"
                                            renderOptions={(option: Conta) => {
                                                return option.nome;
                                            }}
                                            renderOptionsLabel={(option: Conta) => {
                                                return option.nome;
                                            }}
                                            onChange={(value: Conta) => {
                                                const filter: Filter[] = [...filterState];
                                                filter[ANALISTA_FIELD.index].value = value
                                                setFilterState(filter)
                                            }}
                                        />

                                    </div>
                                    <div className="X12 M4">
                                        <InputComboBoxList
                                            multiple
                                            id={`list-etapas-vendas`}
                                            key={`list-etapas-vendas`}
                                            label={"Etapa de Venda"}
                                            textField="text"
                                            valueField="value"
                                            options={LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS}
                                            autoComplete
                                            value={String(filterState[ETAPA_VENDA_FIELD.index]?.value).split(",")?.map((id) => {
                                                const idx = LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS.findIndex((etapa: any) => id === etapa.value);
                                                return idx > -1 ? LISTA_ETAPA_VENDA_PROJETOS_VERTICAIS[idx] : null;
                                            })?.filter(Boolean) || []}
                                            onChange={(value: any[]) => {
                                                const result = [];

                                                for (const etapa of value) {
                                                    result.push(etapa.value);
                                                }

                                                const filter = [...filterState];
                                                const idx = filter.findIndex((f) => f.field === ETAPA_VENDA_FIELD.name);

                                                if (idx > -1) {
                                                    filter[idx].value = result.join(",");
                                                    setFilterState(filter);
                                                }
                                            }}
                                            renderOptions={(option: any) => {
                                                return `${option.text}`
                                            }}
                                            renderOptionsLabel={(option: any) => {
                                                return `${option.text}`
                                            }}
                                        />
                                    </div>
                                    <div className="X12 M2">
                                        <InputSelectSimple
                                            allowNull
                                            list={LISTA_PRIORIDADE_PROJETOS_VERTICAIS}
                                            label="Prioridade"
                                            value={filterState[PRIORIDADE_FIELD.index].value}
                                            onChange={(value) => {
                                                filterState[PRIORIDADE_FIELD.index].value = value;
                                                setFilterState([...filterState]);
                                                dataGridStore.setFilter(filterState);
                                            }}
                                        />
                                    </div>

                                    <div className="X12 M3">
                                        <InputDateTime
                                            label={`Data de etapa de venda (Inicial)`}
                                            fullWidth={true}
                                            value={dataGridStore.getFilterState(DATA_ETAPA_INICIO_FIELD.name, null) || null}
                                            onChange={(date: string | null) => {
                                                const filter = [...filterState];
                                                const idx = filter.findIndex((f) => f.field === DATA_ETAPA_INICIO_FIELD.name);

                                                if (idx > -1) {
                                                    filter[idx].value = date;
                                                    setFilterState(filter);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="X12 M3">
                                        <InputDateTime
                                            label={`Data de etapa de venda (Final)`}
                                            fullWidth={true}
                                            value={dataGridStore.getFilterState(DATA_ETAPA_FINAL_FIELD.name, null) || null}
                                            onChange={(date: string | null) => {
                                                const filter = [...filterState];
                                                const idx = filter.findIndex((f) => f.field === DATA_ETAPA_FINAL_FIELD.name);

                                                if (idx > -1) {
                                                    filter[idx].value = date;
                                                    setFilterState(filter);
                                                }
                                            }}
                                        />
                                    </div>
                                </>
                            }
                            advancedFilters={
                                <>
                                    <div className="row">
                                        <div className="X12 M3">
                                            <InputDateTimeFilter
                                                fullWidth
                                                label="Dt.criação inicial"
                                                fieldFilter={DATA_CRIACAO_INICIAL_FIELD}
                                                filter={filterState[DATA_CRIACAO_INICIAL_FIELD.index]}
                                                onChangeValue={(filter: Filter) => {
                                                    filterState[DATA_CRIACAO_INICIAL_FIELD.index] = filter;
                                                    setFilterState([...filterState])
                                                    setTimeout(() => {
                                                        dataGridStore.setFilter([...filterState]);
                                                    }, 400)
                                                }}
                                            />
                                        </div>
                                        <div className="X12 M3">
                                            <InputDateTimeFilter
                                                fullWidth
                                                label="Dt.criação final"
                                                fieldFilter={DATA_CRIACAO_FINAL_FIELD}
                                                filter={filterState[DATA_CRIACAO_FINAL_FIELD.index]}
                                                onChangeValue={(filter: Filter) => {
                                                    filterState[DATA_CRIACAO_FINAL_FIELD.index] = filter;
                                                    setFilterState([...filterState])
                                                    setTimeout(() => {
                                                        dataGridStore.setFilter([...filterState]);
                                                    }, 400)
                                                }}
                                            />
                                        </div>
                                        <div className="X12 M3">
                                            <InputDateTimeFilter
                                                fullWidth
                                                label="Dt.integração inicial"
                                                fieldFilter={DATA_INTEGRACAO_INICIAL_FIELD}
                                                filter={filterState[DATA_INTEGRACAO_INICIAL_FIELD.index]}
                                                onChangeValue={(filter: Filter) => {
                                                    filterState[DATA_INTEGRACAO_INICIAL_FIELD.index] = filter;
                                                    setFilterState([...filterState])
                                                    setTimeout(() => {
                                                        dataGridStore.setFilter([...filterState]);
                                                    }, 400)
                                                }}
                                            />
                                        </div>
                                        <div className="X12 M3">
                                            <InputDateTimeFilter
                                                fullWidth
                                                label="Dt.integração final"
                                                fieldFilter={DATA_INTEGRACAO_FINAL_FIELD}
                                                filter={filterState[DATA_INTEGRACAO_FINAL_FIELD.index]}
                                                onChangeValue={(filter: Filter) => {
                                                    filterState[DATA_INTEGRACAO_FINAL_FIELD.index] = filter;
                                                    setFilterState([...filterState])
                                                    setTimeout(() => {
                                                        dataGridStore.setFilter([...filterState]);
                                                    }, 400)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            }
                            renderAggregation={(aggregates: any) => {
                                return <>
                                    <div className="row">
                                        <Tooltip title="Total de projetos em prioridade Alta">
                                            <Chip
                                                size="medium"
                                                icon={
                                                    <Avatar aria-label="recipe" style={{ backgroundColor: parsePrioridadeProjetoColor("alta") }}>
                                                        A
                                                    </Avatar>
                                                }
                                                label={`${Formater.toString(aggregates?.prioridade_alta || 0, TypeRecords.INT)}`}
                                                color="secondary"
                                            />
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title="Total de projetos em prioridade Média">
                                            <Chip
                                                size="medium"
                                                icon={
                                                    <Avatar aria-label="recipe" style={{ backgroundColor: parsePrioridadeProjetoColor("media") }}>
                                                        M
                                                    </Avatar>
                                                }
                                                label={`${Formater.toString(aggregates?.prioridade_media || 0, TypeRecords.INT)}`}
                                                color="secondary"
                                            />
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title="Total de projetos em prioridade Baixa">
                                            <Chip
                                                size="medium"
                                                icon={
                                                    <Avatar aria-label="recipe" style={{ backgroundColor: parsePrioridadeProjetoColor("baixa") }}>
                                                        B
                                                    </Avatar>
                                                }
                                                label={`${Formater.toString(aggregates?.prioridade_baixa || 0, TypeRecords.INT)}`}
                                                color="secondary"
                                            />
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title="Total de projetos em pausa">
                                            <Chip
                                                size="medium"
                                                icon={<PauseCircleOutline />}
                                                label={`Pausa: ${Formater.toString(aggregates?.situacao_pausado || 0, TypeRecords.INT)}`}
                                                color="default"
                                            />
                                        </Tooltip>
                                        &nbsp;
                                        <Tooltip title="Total de projetos em SLA de Engenharia">
                                            <Chip
                                                size="medium"
                                                icon={<Settings />}
                                                label={`SLA Engenharia: ${Formater.toString(aggregates?.etapa_sla_engenharia || 0, TypeRecords.INT)}`}
                                                color="default"
                                            />
                                        </Tooltip>
                                        &nbsp;
                                        {/*
                                        <div className="X6 M2" >
                                            <InfoCard
                                                label="SLA Engenharia"
                                                content={Formater.toString(aggregates.etapa_sla_engenharia, TypeRecords.INT)}
                                            />
                                        </div>
                                        <div className="X6 M2" >
                                            <InfoCard
                                                label="Pausado"
                                                content={Formater.toString(aggregates.situacao_pausado, TypeRecords.INT)}
                                            />
                                        </div>
                                        <div className="X6 M2" >
                                            <InfoCard
                                                label="Prioridade Baixa"
                                                content={Formater.toString(aggregates.prioridade_baixa, TypeRecords.INT)}
                                            />
                                        </div>
                                        <div className="X6 M2" >
                                            <InfoCard
                                                label="Prioridade Média"
                                                content={Formater.toString(aggregates.prioridade_media, TypeRecords.INT)}
                                            />
                                        </div>
                                        <div className="X6 M2" >
                                            <InfoCard
                                                label="Prioridade Alta"
                                                content={Formater.toString(aggregates.prioridade_alta, TypeRecords.INT)}
                                            />
                                        </div>
                                        */}
                                    </div>
                                </>
                            }}
                        />
                    </div>
                </TabContent>
                <TabContent
                    name={"edicao"}
                    label={!!currentEdit ? `${(currentEdit as any).codigo_venda}` : ""}
                    visible={currentEdit !== null}
                >

                    <div
                        className="X12 form"
                        hidden={tabManutencao !== `edicao`}
                        key={`div-form-verticais-${currentEdit?.codigo_venda}`}
                    >
                        {currentEdit && <VerticaisForm
                            previousTab={tabManutencao}
                            distribuidores={distribuidoresState?.data || []}
                            revendas={revendasState?.data || []}
                            ev={evsState?.data || []}
                            engenheiros={engenheirosState?.data || []}
                            cidades={cidadeListState?.data || []}
                            componentesCache={componentesState}
                            gruposEstrutura={estruturasState?.data || []}
                            item={currentEdit}
                            readOnly={currentEditReadOnly}
                            updateComponentesCache={(_componentes) => {
                                setComponentesState([...manager.addComponente(componentesState, _componentes)])
                            }}
                            onSave={(verticais: any) => {
                                manager.save({
                                    row: verticais,
                                    primaryKey: verticais?.id
                                }).then((response: IDataResponse) => {
                                    afterSave(response);
                                }).catch((error) => {

                                })
                            }}
                            onFinalizar={(verticais: any) => {
                                manager.save({
                                    row: verticais,
                                    primaryKey: verticais?.id
                                }).then((response: IDataResponse) => {
                                    if(![STATUS_CODE.INTERNAL_SERVER_ERROR, STATUS_CODE.BAD_REQUEST].includes(response.statusCode)){
                                        confirmationDialog.setup({
                                            title: "Aviso!",
                                            content: `Enviar para pagamento com triangulação de nota?`,
                                            onClose: () => {
                                                confirmationDialog.close();
                                                doFinalizar(response.data[0], false)
                                            },
                                            onConfirmation: () => {
                                                confirmationDialog.close();
                                                doFinalizar(response.data[0], true)
                                            }
                                        })
                                        confirmationDialog.open()
                                    }

                                    // afterSave(response);
                                }).catch((error) => {

                                })
                            }}
                            onExit={() => {
                                setCurrentEdit(null);
                                setTabManutencao('list')
                            }}
                        />}
                    </div>

                </TabContent> 
                <TabContent disabled={!permiteNovo} name={"new"} label={<Icon>add</Icon>} visible={true}>
                    <div
                        className="X12 form"
                        key={`div-form-verticais-new`}
                    >
                        {newRow && <VerticaisForm
                            previousTab={tabManutencao}
                            distribuidores={distribuidoresState?.data || []}
                            revendas={revendasState?.data || []}
                            ev={evsState?.data || []}
                            engenheiros={engenheirosState?.data || []}
                            cidades={cidadeListState?.data || []}
                            componentesCache={componentesState}
                            gruposEstrutura={estruturasState?.data || []}
                            updateComponentesCache={(_componentes) => {
                                setComponentesState([...manager.addComponente(componentesState, _componentes)])
                            }}
                            item={newRow}
                            readOnly={false}
                            onSave={(verticais: any) => {
                                if (verticais?.id) {
                                    delete verticais.id
                                }
                                manager.save({
                                    row: verticais
                                }).then((response: IDataResponse) => {
                                    afterSave(response);
                                }).catch((error) => {

                                })
                            }}
                            onExit={() => {
                                const reset: any = { ...DEFAULT_VERTICAIS, }
                                setNewRow(reset);
                                setTabManutencao('list')
                            }}
                        />}
                    </div>
                </TabContent>
            </TabControl>
        </Paper>
        {openRedirectVerticais && (
            <ModalRedirectVerticais open={openRedirectVerticais} onExit={() => {
                setCurrentEdit(null);
                setTabManutencao('list')
            }}/>
        )}
        <ProjetosSolicitacaoPausaModal
            data={dataSolicitacaoPausa}
            open={openSolicitacaoPausa}
            setOpen={setOpenSolicitacaoPausa}
            applyConfirmation={(data: ProjetoSolicitacaoPausaDom) => doSolicitacaoPausa(data)}
        />

        {revendaComServicoDesabilitadoWarningModal.status && (
            <ModalRevendaServicoDesabilitado
                closeModal={() => setRevendaComServicoDesabilitadoWarningModal({ status: false, onConfirm: () => {}, idProjeto: null })}
                isOpen={revendaComServicoDesabilitadoWarningModal.status}
                onConfirm={() => revendaComServicoDesabilitadoWarningModal.onConfirm()}
                idProjeto={revendaComServicoDesabilitadoWarningModal.idProjeto}
            />
        )}
    </>
}

export { VerticaisDataTable }